import { CheckboxInput } from '../baseInputs'

const ContactMirai = ({ ...rest }) => {
  return (
    <div className="mt-8" data-gt-componentname="contact-mirai">
      <CheckboxInput name="notes" {...rest}>
        I would like to be contacted via phone or email to discuss purchasing
        the Mirai
      </CheckboxInput>
    </div>
  )
}

export default ContactMirai
